import React from "react"
import { Row, Col, Form } from "react-bootstrap"
import {
  updateDescOfDamageCheckBox,
  updateDescDamageValue,
} from "../../../../Redux/WindscreenClaim/actions"
import { useDispatch } from "react-redux"

function FormDamageDesc({ ...props }) {
  const { textDesc, claimData } = props

  const dispatch = useDispatch()

  const handleDescOfDamageCheckBox = textDesc => {
    dispatch(updateDescOfDamageCheckBox(textDesc))
  }

  const handleRepairReplacementButton = (textDesc, buttonValue) => {
    dispatch(updateDescDamageValue(textDesc, buttonValue))
  }

  const checkDescOfDamageChecked = description => {
    let index = claimData.claimInfo.claimWindscreenItems.findIndex(
      x => x.damageItem === description
    )
    return index !== -1 ? true : false
  }

  const descOfDamageValue = description => {
    let index = claimData.claimInfo.claimWindscreenItems.findIndex(
      x => x.damageItem === description
    )
    return index !== -1
      ? claimData.claimInfo.claimWindscreenItems[index].damageDesc
      : false
  }

  return (
    <Form.Group>
      <Row>
        <Col
          xs={12}
          md={6}
          className={"textforinput marginTop10px cursorPointer minHeight50px"}
          onClick={() => {
            handleDescOfDamageCheckBox(textDesc)
          }}
        >
          <div
            className={
              "FieldDescCheckBox " +
              (checkDescOfDamageChecked(textDesc) ? "tick" : "")
            }
          ></div>
          <p>{textDesc}</p>
        </Col>

        <Col md={6} xs={12} className="marginTop10px">
          {checkDescOfDamageChecked(textDesc) && (
            <>
              <Col
                md={5}
                xs={5}
                className={
                  "font18 height50 horizontal-align backgroundGrey cursorPointer float-left borderRadius8 YesNobutton " +
                  (descOfDamageValue(textDesc) === "Repair" ? "tick" : "")
                }
                onClick={event => {
                  if (descOfDamageValue(textDesc) !== "Repair") {
                    handleRepairReplacementButton(textDesc, "Repair")
                  }
                }}
                role="button"
                //tabIndex="0"
              >
                <b>Repair</b>
              </Col>
              <Col
                md={5}
                xs={5}
                className={
                  "font18 height50 horizontal-align backgroundGrey cursorPointer float-right borderRadius8 YesNobutton " +
                  (descOfDamageValue(textDesc) === "Replacement" ? "tick" : "")
                }
                onClick={event => {
                  if (descOfDamageValue(textDesc) !== "Replacement") {
                    handleRepairReplacementButton(textDesc, "Replacement")
                  }
                }}
                role="button"
                //tabIndex="0"
              >
                <b>Replacement</b>
              </Col>
            </>
          )}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormDamageDesc
